export enum AddressType {
    HOME_ADDRESS = 1,
    POSTAL_ADDRESS = 2
}
